import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { useFilterBarStyles } from './FilterBar.styles'

export type ChipConfig = {
    key: string
    items: any[]
    labelKey: (item: any) => string
    onDelete: (item: any) => void
    showDivider?: boolean
}

interface FilterChipsProps {
    chips: ChipConfig[]
}

const FilterChips = ({ chips }: FilterChipsProps) => {
    const { t } = useTranslation('filter')
    const styles = useFilterBarStyles()

    return (
        <div className={styles.chipContainer}>
            {chips.map(({ key, items, labelKey, onDelete, showDivider }) => {
                return items?.length > 0 ? (
                    <React.Fragment key={key}>
                        {items.map((item) => (
                            <Chip
                                key={`${key}-${String(item)}`}
                                label={t(labelKey(item))}
                                onDelete={() => onDelete(item)}
                                className={styles.chip}
                            />
                        ))}

                        {showDivider && (
                            <Divider
                                orientation="vertical"
                                className={styles.verticalDivider}
                            />
                        )}
                    </React.Fragment>
                ) : null
            })}
        </div>
    )
}

export default FilterChips